// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './store'
import VueResource from 'vue-resource'
import VueSocketio from 'vue-socket.io'
import VueTour from 'vue-tour'
import VModal from 'vue-js-modal'
import router from './router'
import config from './config'
import OverlayLoading from 'vue-loading-overlay';
import VueCountryRegionSelect from 'vue-country-region-select'
import 'vue-loading-overlay/dist/vue-loading.css';

require('vue-tour/dist/vue-tour.css')

Vue.use(Vuex)
Vue.use(VueResource)
// Vue.use(VueSocketio, config.SERVER_DOMAIN + '/global')
Vue.use(new VueSocketio({
  debug: true,
  connection: config.SERVER_DOMAIN + '/global',
}))

Vue.use(VueTour)
Vue.use(VModal, { componentName: 'vue-modal' })
Vue.use(OverlayLoading)
Vue.use(VueCountryRegionSelect)

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    welcomeInNameSpace: msg => {
      console.log(msg)
    },
  },
})

export default app;
